export const treeType = {
    OPEN_DETAILS: 'openDetails',
    OPEN_MAP: 'openMap',
    OPEN_RELATED_ENTITIES: 'openRelatedEntities',
};
